module.exports = __webpack_public_path__ + "img/mayfair2.162553bc.png";